import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';
import Cookies from 'universal-cookie';
import './InvitesRedirect.less';
import { getMatchingStd } from '../../../../cards/actions/cardCatalogActions';
import { createProject } from '../../../../cards/actions/projectActions';
import { createInvitationAccount } from '../../../../cards/actions/invitationAccountActions';
import { hideModal } from '../../../../actions/ModalActions';
import { getUserContext } from '../../../../actions/UserActions';
import { getUserContext as getUserContextSelector } from '../../../../selectors/authentication/User';

class InvitesRedirectModalVA extends Component {
  constructor(props) {
    super(props);
    this.initiateCountDown = this.initiateCountDown.bind(this);
    this.checkCountDown = this.checkCountDown.bind(this);
    this.state = {
      countDown: 5
    };
  }

  componentWillMount() {
    this.initiateCountDown();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  kickOffTracking(project) {
    const cookies = new Cookies();
    const data = {
      counter: 0,
      project: {
        projectCustomizationUUID: project.customizations[0].uuid,
        envelopeCustomizationUUID: project.customizations[1].uuid,
      },
    };
    // maxAge = 1 week in seconds
    cookies.set('invitesRedirectTest', data, { maxAge: 604800, path: '/' });
  }

  initiateCountDown() {
    this.timer = setInterval(() => {
      this.setState({
        countDown: this.state.countDown - 1,
      });
      this.checkCountDown();
    }, 1000);
  }

  checkCountDown() {
    const { countDown } = this.state;
    const { closeModal, onHandleMatchingStd, weddingThemeKey, onHandleCreateProject, userContext, onCreateInvitationAccount, onGetUserContext } = this.props;
    if (countDown === 0) {
      clearInterval(this.timer);

      onHandleMatchingStd(weddingThemeKey).then((response) => {
        const suiteUUID = response[0].suite_uuid;
        const activeVariationUUID = response[0].lead_variation_uuid;
        const quantity = 100;
        if (!userContext.has_invitation_account) {
          onCreateInvitationAccount().then(onGetUserContext).then(() => {
            onHandleCreateProject(suiteUUID, activeVariationUUID, quantity).then((json) => {
              browserHistory.push(`/wedding-planning/custom/${json.uuid}/detailFront`);
              this.kickOffTracking(json);
            });
          });
        } else {
          onHandleCreateProject(suiteUUID, activeVariationUUID, quantity).then((json) => {
            browserHistory.push(`/wedding-planning/custom/${json.uuid}/detailFront`);
            this.kickOffTracking(json);
          });
        }
      });
      closeModal();
    }
  }

  render() {
    const { countDown } = this.state;
    return (
      <div className="modal-container no-close">
        <div className="doodle glasses" />
        <div className="body-copy">
          <div className="heading">
            <h4><span className="zolaicon-public zolaicon-checkmark checkmark" />Your website is <span className="outter"><span className="line">now visible</span></span>. Yay!</h4>
          </div>
          <div className="subhead">
            <h1>Start your <span className="countdown">matching save the date</span> in <span className="countdown">{countDown}</span></h1>
          </div>
        </div>
      </div>
    );
  }
}

InvitesRedirectModalVA.propTypes = {
  closeModal: PropTypes.func.isRequired,
  onHandleMatchingStd: PropTypes.func,
  weddingThemeKey: PropTypes.string,
  onHandleCreateProject: PropTypes.func,
  userContext: PropTypes.shape({}),
  onCreateInvitationAccount: PropTypes.func,
  detailSuiteLeadCard: PropTypes.shape({}),
  onGetUserContext: PropTypes.func,
};

const mapStateToProps = (state) => { // eslint-disable-line
  return {
    weddingThemeKey: state.wedding.theme.key,
    userContext: getUserContextSelector(state),
  };
};

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(hideModal()),
  onHandleMatchingStd: weddingThemeKey => dispatch(getMatchingStd(weddingThemeKey)),
  onHandleCreateProject: (suiteUUID, activeVariationUUID, quantity) => dispatch(createProject(suiteUUID, activeVariationUUID, quantity)),
  onCreateInvitationAccount: () => dispatch(createInvitationAccount()),
  onGetUserContext: () => dispatch(getUserContext()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvitesRedirectModalVA);



// WEBPACK FOOTER //
// ./src/components/common/modals/InvitesRedirectModal/InvitesRedirectModalVA.jsx